import {checkStatus} from '../../__utils/utils'

export const sendAmocrmData = formRequest => {
  const {name, email, phone, comment, quantity, seidoUuid, locations} = formRequest
  const dataToSend = {
    name,
    email,
    phone,
    title: `${document.location.href} | ${document.title}`
  }
  if (comment) {
    dataToSend.comment = comment
  }

  /* eslint-disable camelcase */
  if (quantity && seidoUuid && locations) {
    dataToSend.seido_schema = [
      {
        quantity,
        seido_uuid: seidoUuid
      }
    ]
    dataToSend.locations = locations
  }
  /* eslint-enable camelcase */

  return fetch('https://api.selectel.ru/proxy/public/amocrm_clients/upsert', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(dataToSend)
  })
  .then(checkStatus)
}